'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schema = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

var _helpers = require('./helpers');

var _novelapi = require('./novelapi');

var _constant = require('./constant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var valid = {
  nocgenre: [1, 2, 3, 4]
};

var schema = exports.schema = _extends({}, _novelapi.schema, {
  xid: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)('[\\d\\w]+')),
  nocgenre: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)(valid.nocgenre)),
  notnocgenre: _joi2.default.string().regex((0, _helpers.createHyphonRegexp)(valid.nocgenre))
});

exports.default = {
  url: _constant.protocol + '//api.syosetu.com/novel18api/api/',
  schema: _joi2.default.object(schema)
};


// WEBPACK FOOTER //
// ./src/api/novel18api.js